import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./lang/messages";

Vue.use(VueI18n);

// Configure VueI18n
export const i18n = new VueI18n({
  // Set the default locale based on the browser's language
  locale: navigator.language.substring(0, 2),
  fallbackLocale: "en",
  messages,
});
